var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.72435 10C2.06601 9.20833 1.66602 8.19167 1.66602 7.08333C1.66602 4.56667 3.72435 2.5 6.24935 2.5H10.416C12.9327 2.5 14.9993 4.56667 14.9993 7.08333C14.9993 9.6 12.941 11.6667 10.416 11.6667H8.33268",
    stroke: "#979EBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.275 10C17.9333 10.7917 18.3333 11.8083 18.3333 12.9167C18.3333 15.4333 16.275 17.5 13.75 17.5H9.58333C7.06667 17.5 5 15.4333 5 12.9167C5 10.4 7.05833 8.33334 9.58333 8.33334H11.6667",
    stroke: "#979EBE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/Icon-Link.32566566bbb60ea34d2fdeda313cbcac.svg";
export { ForwardRef as ReactComponent };